import React from 'react';
import './BaseModal.css';

const BaseModal = ({ isOpen, onClose, title, children, footer, className = '', modalBodyRef }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            {/* // <div className={`modal-overlay ${isOpen ? 'open' : ''}`}> */}
            <div className={`modal-content ${className}`} onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                </div>

                <div className={`modal-body ${className}`} ref={modalBodyRef}>
                    {children}
                </div>

                {footer && (
                    <div className="modal-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BaseModal;